import { render, staticRenderFns } from "./entity-extrafields.vue?vue&type=template&id=69a41b04"
import script from "./entity-extrafields.vue?vue&type=script&lang=js"
export * from "./entity-extrafields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports